import React, { useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';

import Banner from './Banner';
import EventCard from './EventCard';
import { events } from './events-data';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../Atoms';
/**
 * Events (listing page)
 * -------------------------------------------------------
 * /events — a single flex column of full-width event cards.
 * Upcoming events come first (with an "Upcoming" pill), then
 * past events (their date already shows they're past).
 * Both the homepage slider and this page read from the same
 * events-data.js.
 */
export default function Events() {
  useLayoutEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  const upcoming = events.filter((e) => !e.isPast);
  const past = events.filter((e) => e.isPast);
  const allEvents = [...upcoming, ...past];
  const navigate = useNavigate();
  return (
    <>
      <Banner />

      <div className="max-w-7xl containers-min mx-auto px-4 py-8 sm:py-12">
        <div className="text-center mb-8 sm:mb-10">
          {/* <h2 className="font-gilroybold text-2xl sm:text-3xl md:text-4xl">
    A Glimpse into past Events
  </h2>
  */}
        </div>
        {allEvents.length > 0 ? (
          <div className="flex flex-col gap-5 sm:gap-6 w-full">
            {allEvents.map((event) => (
              <EventCard
                key={event.slug}
                event={event}
                showUpcomingPill
                className="w-full"
              />
            ))}
          </div>
        ) : (
          <p className="text-center font-poppins text-black/60 py-12">
            No events to show right now — check back soon.
          </p>
        )}
      </div>

      {/* CTA strip */}
      <div className="bg-[rgb(35,180,85)] bg-opacity-[0.06] py-10 sm:py-14">
        <div className="containers-min mx-auto px-4 text-center">
          <p className="font-bold text-xl sm:text-2xl font-gilroy mb-3">
            Want To Meet Us at an Event?
          </p>
          <p className="font-poppins text-black/70 mb-6  mx-auto">
            Get in touch and we&apos;ll let you know the next time we&apos;ll be
            near you.
          </p>
          <div className="flex justify-center">
            <Button
              title="Get in Touch"
              onClick={() => navigate('/get-in-touch')}
            />
          </div>
        </div>
      </div>
    </>
  );
}
